<div class="w-full flex justify-content-center p-4 md:p-6">
    <div class="policy-container w-full flex flex-column gap-4">
        <div class="flex flex-column gap-3">
            <h1 class="text-3xl font-bold text-indigo-900 m-0">Terms & Conditions Policy</h1>
            <p class="text-700 line-height-3 m-0">
                Welcome to GradPilots. By accessing or using our website, services, or any platform features, you
                agree to
                be bound by the following Terms and Conditions. Please read them carefully.
            </p>
        </div>

        <div class="flex flex-column gap-4">
            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Acceptance of Terms-</h2>
                <p class="text-700 m-0">
                    By using our website, you confirm that you are at least 16 years old or have parental/guardian
                    consent,
                    and you accept these terms and our privacy practices.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Services Offered</h2>
                <p class="text-700 m-0">
                    GradPilots provides education counseling, mentorship programs, and application support services
                    for
                    students aspiring to study in India or abroad.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">User Responsibilities</h2>
                <ul class="text-700 m-0 flex flex-column gap-2 list-none p-0">
                    <li class="flex align-items-start gap-2">
                        <span class="text-900">•</span>
                        <span>You agree to provide accurate information and keep it updated.</span>
                    </li>
                    <li class="flex align-items-start gap-2">
                        <span class="text-900">•</span>
                        <span>You agree not to misuse the platform, harass mentors or staff, or infringe on any
                            intellectual
                            property rights.</span>
                    </li>
                </ul>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Intellectual Property</h2>
                <p class="text-700 m-0">
                    All content on this platform including text, logos, graphics, and software is the property of
                    GradPilots
                    and may not be copied or reused without permission.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Third-Party Links</h2>
                <p class="text-700 m-0">
                    GradPilots may include links to third-party sites. We are not responsible for their content or
                    services.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Payment Terms</h2>
                <p class="text-700 m-0">
                    All fees are to be paid in full as per the selected package. GST and other applicable taxes are
                    extra.
                    Late or incomplete payments may result in service suspension.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Termination</h2>
                <p class="text-700 m-0">
                    We reserve the right to suspend or terminate access for any user who violates our terms or
                    engages in
                    unethical behaviour.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Limitation of Liability</h2>
                <p class="text-700 m-0">
                    GradPilots shall not be held liable for any indirect or incidental damages arising from the use
                    or
                    inability to use the services.
                </p>
            </section>

            <section class="flex flex-column gap-2">
                <h2 class="text-xl font-semibold text-900 m-0">Changes to Terms</h2>
                <p class="text-700 m-0">
                    We may update these Terms periodically. Continued use of the platform implies your consent to
                    the
                    revised terms.
                </p>
                <p class="text-700 m-0">
                    For queries, contact: <a href="mailto:support@gradpilots.com"
                        class="text-indigo-600 no-underline hover:underline font-medium">support&#64;gradpilots.com</a>
                </p>
            </section>
        </div>

        <div class="flex flex-column gap-3 mt-4">
            <p-accordion [multiple]="false">
                <p-accordionTab header="Privacy Policy">
                    <div class="text-700">
                        <p class="m-0 mb-3">
                            At GradPilots, we are committed to protecting your privacy. This policy explains how we
                            collect,
                            use, store, and disclose your personal information.
                        </p>
                        <ul class="m-0 p-0 list-none flex flex-column gap-2">
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Information We Collect:</span> Name, email, phone
                                    number, academic records, SOPs, device data.</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">How We Use Your Data:</span> Customized guidance,
                                    analytics, communications, testimonials (with consent).</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Data Sharing:</span> With university partners (with
                                    consent), mentors, and trusted third-party providers.</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Data Protection:</span> We use industry-standard
                                    protocols to safeguard your data.</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Your Rights:</span> Request to view, update, or delete
                                    data at support&#64;gradpilots.com</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Cookies:</span> Used for improving experience; disable
                                    via browser if preferred.</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Policy Updates:</span> Continued usage implies
                                    acceptance of any future changes.</span>
                            </li>
                        </ul>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="Refund Cancellation Policy">
                    <div class="text-700">
                        <p class="m-0 mb-3">
                            At GradPilots, we strive to deliver exceptional, value-driven services through
                            personalized
                            guidance and mentorship. Our refund and cancellation policy is designed to be fair,
                            transparent,
                            and reflective of the time and effort our team invests.
                        </p>
                        <ul class="m-0 p-0 list-none flex flex-column gap-2">
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">General Policy:</span> All payments are
                                    non-refundable, non-adjustable, and non-transferable once service begins.</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span>Applies to mentorship, document review, counseling, and application support
                                    services.</span>
                            </li>
                            <li class="flex align-items-start gap-2">
                                <span class="text-900">•</span>
                                <span><span class="font-semibold">Contact Us:</span> Write to <a
                                        href="mailto:support@gradpilots.com"
                                        class="text-indigo-600 no-underline hover:underline">support&#64;gradpilots.com</a>
                                    with your name, email, package, date, and reason.</span>
                            </li>
                        </ul>
                    </div>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>
</div>